import { IS_PREVIEW } from '@/utils/env';
import { pushToElevarDataLayer, getUserProperties } from './utils';
import { ElevarAuthEvent } from './types';

/**
 * Elevar signup tracking.
 * Call this function when a user creates a new account.
 * If account management is handled on Shopify's online store, this can be disregarded.
 */
export const handleElevarSignUp = (userProperties?: any) => {
  if (IS_PREVIEW) return;

  // Use provided user properties or get default ones
  const finalUserProperties = userProperties || getUserProperties();

  const event: ElevarAuthEvent = {
    event: 'dl_sign_up',
    user_properties: {
      ...finalUserProperties,
      visitor_type: 'logged_in' // User just signed up, so they're now logged in
    }
  };

  pushToElevarDataLayer(event);
};

/**
 * Elevar login tracking.
 * Call this function when a user logs into their account.
 * If account management is handled on Shopify's online store, this can be disregarded.
 */
export const handleElevarLogin = (userProperties?: any) => {
  if (IS_PREVIEW) return;

  // Use provided user properties or get default ones
  const finalUserProperties = userProperties || getUserProperties();

  const event: ElevarAuthEvent = {
    event: 'dl_login',
    user_properties: {
      ...finalUserProperties,
      visitor_type: 'logged_in'
    }
  };

  pushToElevarDataLayer(event);
};